function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

const screenshotsAccordion = () => {
  //Screenshots accordion
  const panels = document.querySelectorAll('.feature-row');
  let openedPanel = document.querySelectorAll('.open-feature')[0];

  async function toggleOpen() {
    let currentPanel = document.querySelectorAll('.open-feature')[0];

    if (!this.classList.contains('open-feature')) {
      if (openedPanel) openedPanel.classList.remove('open-feature');
      this.classList.add('open-feature');
      openedPanel = this;
      let featureImg = openedPanel.getAttribute('data-feature-img');
      let featureSkin = openedPanel.getAttribute('data-feature-skin');
      let featureIcon = openedPanel.getAttribute('data-feature-icon');
      let currentSkin = currentPanel.getAttribute('data-feature-skin');
      let screenshots = document.querySelectorAll('.screenshot');
      let widget = document.querySelector('#home-features');
      let accent = document.querySelector('.bottom-accent');
      let accents = document.querySelectorAll('.bottom-accent');
      screenshots.forEach(function (el) {
        el.style.opacity = 0;
        el.style.transform = 'translateX(20%)';
      });

      if (typeof featureSkin != 'undefined' && featureSkin != null) {
        accent.style.transform = 'scale(0)';
        await sleep(360);
        screenshots.forEach(function (el) {
          el.style.backgroundImage = 'url(' + featureImg + ')';
        });
        accents.forEach(function (es) {
          es.style.backgroundImage = 'url(' + featureIcon + ')';
        });
        await sleep(360);
        widget.classList = featureSkin + ' buddy-' + featureSkin;
        screenshots.forEach(function (el) {
          el.style.opacity = 1;
          el.style.transform = 'none';
        });

        accent.style.opacity = 1;
        accent.style.transform = 'none';
      } else {
        await sleep(360);
        screenshots.forEach(function (el) {
          el.style.backgroundImage = 'url(' + featureImg + ')';
        });
        accents.forEach(function (es) {
          es.style.backgroundImage = 'url(' + featureIcon + ')';
        });

        await sleep(360);
        screenshots.forEach(function (el) {
          el.style.opacity = 1;
          el.style.transform = 'none';
        });
      }
    }
  }
  panels.forEach((panel) => panel.addEventListener('click', toggleOpen));
};

export { screenshotsAccordion };
